import React from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { FormItem } from '../../app/form/item/item';
import { TextField } from '../../app/form/textfield/textfield';
import { Button } from '../../app/form/button/button';
import { BecomePartnerMobxDto } from '../../../models/mobx/dtos/partner/become-partner-mobx-dto';

export type BecomePartnerFormType = {
    onSubmit: (values: BecomePartnerMobxDto) => void;
    email?: string;
};

export const BecomePartnerForm: React.FC<BecomePartnerFormType> = observer((props) => {
    const { t } = useTranslation();
    const { onSubmit, email } = props;

    const initialValues = new BecomePartnerMobxDto({
        email: email ?? '',
    });
    const validationSchema = yup.object({
        email: yup
            .string()
            .required(t('layout.forms.common.emailValidationRequired'))
            .email(t('layout.forms.common.emailValidationValid')),
        phone: yup
            .string()
            .required(t('layout.forms.common.phoneValidationRequired'))
            .matches(/^\+420[1-9][0-9]{8}$/, t('layout.forms.common.phoneValidationValid')),
        name: yup.string().required(t('layout.forms.common.nameValidationRequired')),
    });

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ values, handleChange, touched, handleBlur, errors, handleSubmit }) => (
                <Form id={'become-partner-form'}>
                    <FormItem>
                        <TextField
                            appearance="web"
                            fullWidth
                            label={t('layout.forms.common.nameField')}
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={touched.name && errors.name ? errors.name : ''}
                            error={Boolean(touched.name && errors.name)}
                        />
                    </FormItem>
                    <FormItem>
                        <TextField
                            appearance="web"
                            fullWidth
                            label={t('layout.forms.common.emailField')}
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={touched.email && errors.email ? errors.email : ''}
                            error={Boolean(touched.email && errors.email)}
                        />
                    </FormItem>
                    <FormItem>
                        <TextField
                            appearance="web"
                            fullWidth
                            label={t('layout.forms.common.phoneField')}
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={touched.phone && errors.phone ? errors.phone : ''}
                            error={Boolean(touched.phone && errors.phone)}
                        />
                    </FormItem>
                    <FormItem>
                        <Button
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            block
                            variant="primary"
                        >
                            {t('layout.forms.becomePartner.submit')}
                        </Button>
                    </FormItem>
                </Form>
            )}
        </Formik>
    );
});
